module.exports = __webpack_public_path__ + "img/uoo.3ac754d4.png";